import classNames from 'classnames';
import { GetStoreMetadata } from '@/data';
import { SPACING_VALUES } from '@/utils';
import { Container } from '../Container';
import ProductPlaceholder from '../Product/ProductPlaceholder';

import styles from './productslist.module.scss';
import { CSSProperties } from 'react';

const ProductListSkeleton = async () => {
  const data = await GetStoreMetadata();
  const productCard = data?.productCard;
  const isLargeCard = productCard?.product_card_large;
  const spacingBetween = productCard?.spacing_between_card;

  const selectedSpacing =
    SPACING_VALUES[spacingBetween] || SPACING_VALUES.small;

  return (
    <Container
      className={classNames(styles.container, styles.skeleton_container)}
    >
      <div
        className={classNames(styles.content, styles.content__placeholder, {
          [styles.content__large]: isLargeCard,
        })}
        style={
          {
            '--gap-default': `${selectedSpacing.default}px`,
            '--gap-sm': `${selectedSpacing.sm}px`,
            '--gap-md': `${selectedSpacing.md}px`,
            '--gap-xl': `${selectedSpacing.xl}px`,
            '--gap-xxl': `${selectedSpacing.xxl}px`,
          } as CSSProperties
        }
      >
        {new Array(20).fill(null).map((_, index) => (
          <ProductPlaceholder key={index} largeCard={isLargeCard} />
        ))}
      </div>
    </Container>
  );
};

export { ProductListSkeleton };
